import React, {Component} from "react";
import CustomPage from "./CustomPage";

export default class PAGE404 extends Component {
  render() {
    return <CustomPage status="404" title="Something went wrong" />;
  }
}
